module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07448_banner_800x600.550996a5.png";